import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/auth.slice";
import statsReducer from "./statistics/statistics.slice";
import predictionReducer from "./prediction/prediction.slice";
import userReducer from "./user/user.slice";
import contactReducer from "./contact/contact.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    stats: statsReducer,
    user: userReducer,
    prediction: predictionReducer,
    contact: contactReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
